module.exports = __webpack_public_path__ + "img/red.6018566c.jpg";